import { Box, Divider, Flex, Input, Select, Stack, Text } from '@chakra-ui/react';
import { ColumnSort } from '@tanstack/react-table';

import { getColumnLabel } from '../../utils/tableUtils';
import { SegmentedControls } from '../SegmentedControls';

export const FinalizeWidget = ({
    title,
    setTitle,
    sort,
    setSort,
    columnIds,
}: {
    title: string;
    setTitle: (title: string) => void;
    sort?: ColumnSort[];
    setSort: (sort: ColumnSort[]) => void;
    columnIds: string[];
}) => {
    return (
        <Stack gap={6}>
            <Box>
                <Text mb={2}>Widget title</Text>
                <Input
                    value={title}
                    onChange={(ev) => setTitle(ev.target.value)}
                    placeholder="Widget Jones's Diary"
                    size="sm"
                />
            </Box>

            <Divider />

            <Box>
                <Text mb={2}>
                    Initial sorting{' '}
                    <Text as="span" color="gray.400">
                        (optional)
                    </Text>
                </Text>
                <Flex gap={4}>
                    <Select
                        size="sm"
                        value={sort?.[0]?.id}
                        onChange={(ev) => setSort([{ id: ev.target.value, desc: true }])}
                    >
                        <option></option>
                        {columnIds.map((columnId) => (
                            <option key={columnId} value={columnId}>
                                {getColumnLabel(columnId)}
                            </option>
                        ))}
                    </Select>

                    {sort?.[0]?.id && (
                        <SegmentedControls
                            stretch
                            variant="solid"
                            size="sm"
                            options={[
                                { label: 'Descending', value: 'desc' },
                                { label: 'Ascending', value: 'asc' },
                            ]}
                            onClick={(value) => setSort([{ id: sort?.[0].id, desc: value === 'desc' }])}
                            selectedValue={sort?.[0]?.desc ? 'desc' : 'asc'}
                        />
                    )}
                </Flex>
            </Box>
        </Stack>
    );
};
